import moment from 'moment'
export default {
	filters: {
		formatDateTime(date_time, format = 'MMM Do [@] hh:mm:ss A'){
			return date_time !== null ? moment(date_time).format(format) : null;
		}
	},
	data: () => ({
		input_config: {
			textarea_autosize: true
			// {
			// 	minRows: 10,
			// 	maxRows: 10000
			// }
		}
	})
}
